import { React, useState, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import _ from "lodash";
import clsx from "clsx";
import Constants from "../../../../constants";
import * as userSelectors from "../../../../selectors/user";
import { useSelector } from "react-redux";
import Table from "react-bootstrap/Table";
import GeneralPaymentDisclaimerRemark from "../../../EPayment/GeneralPaymentDisclaimerRemark";

const paymentTermData = [
  {
    title: "No",
    value1: "1",
    value2: "Description",
    value3:
        "For fund transfer via bank platform (IBG/ Cash/ Cheque etc. ) Submit proof of deposit to TA Securities",
    value4: "For fund transfer via TA Securities FPX platform by using internet banking",
    width: "50px",
  },
  {
    title: "Payment Method",
    value1: "2",
    value2: "Transaction Limit",
    value3: "No Transaction Limit",
    value4: (
        <>
          Minimum transaction limit - RM1,000
          <br /> Maximum transaction limit - RM 250,000
        </>
    ),
    width: "100px",
  },
  {
    title: "Manual Transfer",
    value1: "3",
    value2: "Processing Time",
    value3: (
        <>
          8.30am - 5.00pm
          <br />
          Trading limit will be given upon verification of funds in our bank account.
          <br />
          Fund transfer after 3.00pm will be processed by the next working day.
        </>
    ),
    value4: "7.30am - 5.00pm Trading limit will be given upon confirmation",
    width: "300px",
  },
  {
    title: "FPX Direct Transfer",
    value1: "4",
    value2: "Admin Fees Charges",
    value3: (
        <>
          A service fee of RM1 per transaction will be charged for any refund of third party funds.
        </>
    ),
    width: "250px",
  },
];
function MainDeposit({
  config,
  accountSelections,
  selectedAccountId,
  selectedCurrencyId,
  handleAccountChange,
  currency,
  paymentMethods,
  selectedOption,
  handleRadioChange,
  handleGoBack,
  handleContinue,
  tradeId,
  currenciesSelections,
  handleCurrencyChange,
  onlineCurrencyCheck,
  manualCurrencyCheck,
  isDepositOperate
}) {
  return (
    <>
      <div className={clsx("custom-table-info-container padding-12px")}>
        <div className="fpx-transfer-content">
          <div className="fpx-transfer-content-inner">
            <div className="fpx-transfer-content-input padding-12px my-2">
              <p className="fpx-transfer-content-inner-label">Client Code</p>
              {/*<Form.Control type="text" value={tradeId} disabled />*/}
              {/*<Form.Select*/}
              {/*  className="formControl"*/}
              {/*  value={selectedAccountId}*/}
              {/*  onChange={handleAccountChange}*/}
              {/*  name="accountNumber"*/}
              {/*  style={{ height: "100%" }}*/}
              {/*>*/}
              {/*  {_.map(accountSelections, (account, index) => (*/}
              {/*    <option key={index} value={account.id}>*/}
              {/*      {userSelectors.getUserAccountText(account)}*/}
              {/*    </option>*/}
              {/*  ))}*/}
              {/*</Form.Select>*/}
              <Form.Select
                className="formControl"
                value={selectedAccountId}
                onChange={handleAccountChange}
                name="accountNumber"
                style={{ height: "100%" }}
                disabled={!isDepositOperate}
              >
                {_.map(accountSelections, (account, index) => (
                  <option key={index} value={account.key}>
                    {userSelectors.getUserAccountText(account)}
                  </option>
                ))}
              </Form.Select>
            </div>
            <div className="fpx-transfer-content-input padding-12px my-2">
              <p className="fpx-transfer-content-inner-label">Currency</p>
              {/*<Form.Control type="text" value={currency} disabled />*/}
              <Form.Select
                className="formControl"
                value={selectedCurrencyId && selectedCurrencyId.key}
                onChange={handleCurrencyChange}
                name="accountNumber"
                style={{ height: "100%" }}
                disabled={!isDepositOperate}
              >
                {_.map(currenciesSelections, (currency, index) => (
                  <option key={index} value={currency.key}>
                    {userSelectors.getUserAccountText(currency)}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>
        </div>
        <br />
        <div className="d-flex justify-content-center">
        <div className="d-flex justify-content-center text-center py-3 flex-md-row flex-column align-items-start">
          {paymentMethods.map((method) => {
            const currencyCheck =
              method.value === "deposit-fpx-transfer"
                ? onlineCurrencyCheck
                : method.value === "deposit-manual"
                  ? manualCurrencyCheck
                  : [];
            return (
              <div key={method.value} className="radio-label">
                <Form.Check
                  id={`radio-${method.value}`}
                  inline
                  label={method.label}
                  name="paymentMethod"
                  type="radio"
                  className="radio-button-transaction"
                  value={method.value}
                  disabled={
                    !_.some(
                      currencyCheck,
                      _.matchesProperty(
                        "value",
                        selectedCurrencyId && selectedCurrencyId.key,
                      ),
                    ) || !isDepositOperate
                  }
                  onChange={() => handleRadioChange(method.value)}
                  checked={selectedOption === method.value}
                />
                {/*{!_.isEmpty(config) && selectedOption === method.value &&*/}
                {/*!_.includes(method.value === 'deposit-fpx-transfer' ? onlineCurrencyCheck : method.value === 'deposit-manual' ? manualCurrencyCheck : [], selectedCurrencyId) ? (*/}
                {/*    <span className="form-check-error">*Currency is not supported.</span>*/}
                {/*) : (*/}
                {/*    false*/}
                {/*)}*/}
                {!_.isEmpty(config) &&
                !_.some(
                  currencyCheck,
                  _.matchesProperty(
                    "value",
                    selectedCurrencyId && selectedCurrencyId.key,
                  ),
                ) ? (
                  <span className="form-check-error">
                    *Currency is not supported.
                  </span>
                ) : (
                  false
                )}
              </div>
            );
          })}
        </div>
        </div>
        <br />
        <div className="d-flex justify-content-center py-3">
          <button
            className={clsx("btn custom-button-back")}
            type="submit"
            onClick={handleGoBack}
          >
            Back
          </button>
          <button
            className={clsx("btn custom-button-primary")}
            type="submit"
            style={{ backgroundColor: "#9D7905" }}
            onClick={handleContinue}
            disabled={
              !_.some(
                selectedOption === "deposit-fpx-transfer"
                  ? onlineCurrencyCheck
                  : selectedOption === "deposit-manual"
                    ? manualCurrencyCheck
                    : [],
                _.matchesProperty(
                  "value",
                  selectedCurrencyId && selectedCurrencyId.key,
                ),
              ) || !isDepositOperate
            }
          >
            Continue
          </button>
        </div>
        <div className="text-center py-3">
          <span className="warning-notice">
            *No Third Party Fund Transfer is allowed
          </span>
        </div>
      </div>
    </>
  );
}

export default MainDeposit;
